import React, {Component} from 'react';
import '../../../../style/PresenceAbsence.css'
import {Link} from "react-router-dom";
import BuildingContext from "../../../../contexts/Building";
import FloorAndBedLoading from "../../../loading/FloorAndBedLoading";
import {BsDoorClosed} from 'react-icons/bs';
import api, { refreshAccessToken } from '../../../../api/client';

class PresenceAbsenceRoomPerson extends Component {
    static contextType = BuildingContext;
    state = {
        rooms: [],
        unit: [],
        isLoading: false,
        daysInMonth: 31,
        monthPrefix: '',
        loadedUnitId: null,
        togglingKey: null,
        searchQuery: '',
    }

    resolveUnitId = () => this.context.unitIdPA || this.context.unitId || '';
    resolveUnitNumber = () => this.context.unitNumberPA || this.context.unitNumber || '';

    componentDidMount = async () => {
        const today = new Date().toLocaleDateString('fa-IR-u-nu-latn', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            formatMatcher: 'basic'
        });
        const parts = today.split('/');
        const year = Number(parts[0]);
        const month = Number(parts[1]);
        const daysInMonth = this.jalaliDaysInMonth(year, month);
        this.setState({
            daysInMonth,
            monthPrefix: `${parts[0]}/${parts[1]}`,
        });
        this.loadRooms();
    }

    componentDidUpdate() {
        const unitId = this.resolveUnitId();
        if (unitId && unitId !== this.state.loadedUnitId && !this.state.isLoading) {
            this.loadRooms();
        }
    }

    jalaliDaysInMonth = (jy, jm) => {
        if (jm <= 6) return 31;
        if (jm <= 11) return 30;
        return ((jy % 33) % 4 === 1) ? 30 : 29;
    }

    loadRooms = async () => {
        const unitId = this.resolveUnitId();
        if (!unitId) {
            this.setState({isLoading: false, rooms: [], loadedUnitId: null});
            return;
        }

        this.setState({isLoading: true, loadedUnitId: unitId});
        try {
            const data = await api.get(`/api/v1/supervisor/unit/person/${unitId}`).then(r => r.data);
            this.setState({
                rooms: Array.isArray(data) ? data : [],
                isLoading: false,
            });
        } catch (e) {
            this.setState({isLoading: false, rooms: []});
        }
    }

    applyOptimistic = (personId, day, marked, newRecordId) => {
        const rooms = (this.state.rooms || []).map((room) => ({
            ...room,
            information: (room.information || []).map((info) => {
                if (info.personId !== personId) {
                    return info;
                }
                const cleaningDays = [...(info.cleaningDays || [])];
                if (marked?.recordId) {
                    return {
                        ...info,
                        cleaningDays: cleaningDays.filter((d) => d.recordId !== marked.recordId && Number(d.day) !== day),
                    };
                }
                const dayStr = String(day).padStart(2, '0');
                const date = `${this.state.monthPrefix}/${dayStr}`;
                cleaningDays.push({day, recordId: newRecordId || `temp-${day}`, date});
                return {...info, cleaningDays};
            }),
        }));
        this.setState({rooms});
    }

    toggleCleaningDay = async (room, info, day, marked) => {
        const key = `${info.personId}-${day}`;
        if (this.state.togglingKey === key) {
            return;
        }
        const dayStr = String(day).padStart(2, '0');
        const date = `${this.state.monthPrefix}/${dayStr}`;

        this.setState({togglingKey: key});
        // Optimistic: flip UI immediately
        this.applyOptimistic(info.personId, day, marked, null);

        try {
            if (marked?.recordId && !String(marked.recordId).startsWith('temp-')) {
                await api.delete(`/api/v1/supervisor/record/${marked.recordId}`);
            } else {
                await api.post(`/api/v1/supervisor/record`, {
                    date,
                    title: 'cleaning',
                    personId: info.personId,
                    checkCleaning: true,
                });
            }
            await this.refreshAfterToggle();
        } catch (e) {
            // revert by reloading
            await this.refreshAfterToggle();
            const status = e?.response?.status;
            if (status === 401 || status === 403) {
                try {
                    const token = await refreshAccessToken();
                    if (!token) {
                        window.alert('نشست منقضی شده؛ دوباره وارد شوید');
                        return;
                    }
                    // retry once
                    if (marked?.recordId && !String(marked.recordId).startsWith('temp-')) {
                        await api.delete(`/api/v1/supervisor/record/${marked.recordId}`);
                    } else {
                        await api.post(`/api/v1/supervisor/record`, {
                            date,
                            title: 'cleaning',
                            personId: info.personId,
                            checkCleaning: true,
                        });
                    }
                    await this.refreshAfterToggle();
                } catch (e2) {
                    window.alert('نشست منقضی شده؛ دوباره وارد شوید');
                }
            } else {
                const msg = e?.response?.data?.message || e?.message || '';
                window.alert(`ثبت/حذف نظافت ناموفق بود${msg ? `: ${msg}` : ''}`);
            }
        } finally {
            this.setState({togglingKey: null});
        }
    }

    refreshAfterToggle = async () => {
        try {
            const unitId = this.resolveUnitId();
            const data = await api.get(`/api/v1/supervisor/unit/person/${unitId}`).then(r => r.data);
            this.setState({rooms: Array.isArray(data) ? data : []});
        } catch (e) {
            this.loadRooms();
        }
    }

    render() {
        const days = Array.from({length: this.state.daysInMonth}, (_, i) => i + 1);
        const q = (this.state.searchQuery || '').trim().toLowerCase();
        const rooms = (this.state.rooms || []).map((r) => {
            if (!q) return r;
            const information = (r.information || []).filter((b) => {
                const name = String(b.personName || '').toLowerCase();
                const bed = String(b.bedName || '').toLowerCase();
                return name.includes(q) || bed.includes(q);
            });
            return {...r, information};
        }).filter((r) => !q || (r.information || []).length > 0);

        return (
            <>
                <div className="page-title-row">
                    <h4>نوبت نظافت شبانه</h4>
                    <div className="page-actions">
                        <Link className="back-btn" to="/dashboard/PresenceAbsence">
                            بازگشت
                            <i className="bi bi-caret-left-fill"/>
                        </Link>
                    </div>
                </div>
                <div className="presence-absence">
                    <div className="title-page" style={{fontSize:'14px'}}>
                        <i className="bi bi-building ms-2"/>واحد {this.resolveUnitNumber()}
                    </div>
                    <div className="mb-3">
                        <input
                            type="search"
                            className="form-control"
                            placeholder="جستجو نام اقامتگر یا تخت..."
                            value={this.state.searchQuery}
                            onChange={(e) => this.setState({searchQuery: e.target.value})}
                        />
                    </div>
                    {
                        this.state.isLoading ? (
                            <div className='row' style={{marginTop: "60px"}}>
                                <FloorAndBedLoading/>
                            </div>
                        ) : (
                            <div className='row'>
                                {rooms.map((r) => (
                                    <div className="col-12 p-2" key={r.roomNumber}>
                                        <div className='pa-floor'>
                                            <div className="title"><BsDoorClosed style={{fontSize:"20px"}} className={'ms-1'} />اتاق {r.roomNumber}</div>
                                            <div className='units-list row'>
                                                {
                                                    (r.information || []).map((b) => (
                                                            <div
                                                                className='units-list-item cleaning-person-row col-12 my-2'
                                                                key={`${r.roomNumber}-${b.personId || b.bedName}`}
                                                            >
                                                                <div className="cleaning-person-name">
                                                                    <i className="bi bi-person ms-1"/>
                                                                    {
                                                                        b.personId === null
                                                                        ? <p>تخت خالی است!</p>
                                                                            : <p>{b.personName} — تخت {b.bedName}</p>
                                                                    }
                                                                </div>
                                                                {
                                                                    b.personId !== null ? (
                                                                        <div className="cleaning-days d-flex flex-wrap gap-1 mt-2 justify-content-center">
                                                                            {days.map((day) => {
                                                                                const marked = (b.cleaningDays || []).find((d) => Number(d.day) === day);
                                                                                const busy = this.state.togglingKey === `${b.personId}-${day}`;
                                                                                return (
                                                                                    <button
                                                                                        type="button"
                                                                                        key={day}
                                                                                        disabled={busy}
                                                                                        className={`btn btn-sm ${marked ? 'btn-success' : 'btn-outline-secondary'}`}
                                                                                        style={{minWidth: '2rem', padding: '0.15rem 0.35rem', pointerEvents: 'auto'}}
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            this.toggleCleaningDay(r, b, day, marked);
                                                                                        }}
                                                                                    >
                                                                                        {day}
                                                                                    </button>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    ) : null
                                                                }
                                                            </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                </div>
            </>
        );
    }
}

export default PresenceAbsenceRoomPerson;
